/**
 * Publish-directly (mode=publish) is allowed only when the listing has live state.
 * PCS-11014 Bug 7.
 */
export const resolveListingAttachMode = (hasLive, mode) => (
  hasLive ? (mode || 'draft') : 'draft'
);
